(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .config(config);

    config.$inject = ['$mdDateLocaleProvider', 'moment'];

    /* @ngInject */
    function config($mdDateLocaleProvider, moment) {
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, ['DD.MM.YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD'], true);
            return dateString == null ? null : m.toDate();
        };

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD.MM.YYYY') : '';
        };
    }
})();

